









































































import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/store';
import MainLayout from '@/layouts/Main.vue';
import AnnouncementsService from '@/services/announcements';
import { Lang } from '@/lang/en/announcements.ts';
import ConfirmationDialog from '@/components/form/ConfirmationDialog.vue';
import EventBus from '@/event-bus';
import VForm from 'vuetify/src/components/VForm';

@Component({
    components: {
        MainLayout,
        ConfirmationDialog,
    },
})
export default class Announcements extends Vue {
    private lang: any = Lang;
    private announcementBody: any = { id: null, title: null, description: null, link_label: null, link_location: null };
    private maxRows: number = 5;
    private dialog: boolean = false;
    private deleteBtnVisible: boolean = false;
    private formValid: boolean = false;

    get latestAnnouncements() {
        return store.getters['Announcements/getCurrentAnnouncements'];
    }

    get titleRules() {
        return [
            (v) => !!v || this.lang.form.title.required,
            (v) => v && v.length < 25 || this.lang.form.title.maxLength,
        ];
    }

    get descriptionRules() {
        return [
            (v) => !!v || this.lang.form.description.required,
            (v) => v && v.length < 150 || this.lang.form.description.maxLength,
        ];
    }

    private beforeCreate() {
        AnnouncementsService.Get();
    }

    private async destroy() {
        try {
            await AnnouncementsService.Delete(this.announcementBody.id);
            this.deleteBtnVisible = false;
            this.dialog = false;
            this.clearFields();
            EventBus.ToastEvent.emitGlobalSuccess(Lang.toast.remove, true, 6000);
        } catch (e) {
            EventBus.ToastEvent.emitGlobalError(Lang.toast.error, true, 6000);
        }
    }

    private clearFields() {
        (this.$refs.form as VForm).reset();
    }

    private showDialog() {
        this.dialog = true;
    }

    private closeDialog() {
        this.dialog = false;
    }

    private storeComponentFields(data) {
        this.announcementBody.id = data.id;
        this.announcementBody.title = data.title;
        this.announcementBody.description = data.description;
        this.announcementBody.link_label = data.link_label;
        this.announcementBody.link_location = data.link_location;
        return this.announcementBody;
    }

    private async doSave() {
        try {
            await AnnouncementsService.Save(this.announcementBody);
            EventBus.ToastEvent.emitGlobalSuccess(Lang.toast.success, true, 6000);
            this.deleteBtnVisible = true;
        } catch (e) {
            EventBus.ToastEvent.emitGlobalError(Lang.toast.error, true, 6000);
        }
    }

    @Watch('latestAnnouncements', { deep: true })
    private onChange(newValue: any) {
        if (newValue !== '') {
            this.deleteBtnVisible = true;
            return this.storeComponentFields(newValue);
        }
    }
}
